import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import localStorageHelper from '@/helpers/localStorageHelper';
import { FROM_ROUTER } from '@/helpers/constants';
// import authService from '@/services/authService';
// const PageTemplate = () => import(/* webpackPrefetch: true, webpackChunkName: "login-page" */ '@/views/PageTemplate');

import PageTemplate from '@/views/PageTemplate';
import MainPage from '@/views/MainPage';
import JianWeiRedirect from '@/views/JianWeiRedirect';
import RedirectPage from '@/views/RedirectPage';

const HistoryPage = () => import(/* webpackChunkName: "history-page" */ '@/views/HistoryPage');
const RechargePage = () => import(/* webpackChunkName: "recharge-page" */ '@/views/RechargePage');
const RechargeResultPage = () => import(/* webpackChunkName: "recharge-result-page" */ '@/views/RechargeResultPage');
const UserCenterPage = () => import(/* webpackChunkName: "user-center-page" */ '@/views/UserCenterPage');
const CollectionPage = () => import(/* webpackChunkName: "collection-page" */ '@/views/CollectionPage');
const PdfDetailPage = () => import(/* webpackChunkName: "pdf-detail-page" */ '@/views/PdfDetailPage');
const UserCenterRedirectPage = () => import(/* webpackChunkName: "user-center-redirect-page" */ '@/views/UserCenterRedirectPage');
const MyFeedback = () => import(/* webpackChunkName: "my-feedback" */ '@/views/MyFeedback');
const ErrorPage = () => import(/* webpackChunkName: "error-page" */ '@/views/ErrorPage');

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/jianwei',
      component: JianWeiRedirect,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      component: PageTemplate,
      meta: {
        requiresAuth: true
      },
      children: [
        {  
          path: '/',
          name: 'main-page',
          component: MainPage
        },
        {
          path: '/collection',
          name: 'collection',
          component: CollectionPage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/history',
          name: 'history',
          component: HistoryPage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/recharge',
          name: 'recharge',
          component: RechargePage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/recharge-result',
          name: 'recharge-result',
          component: RechargeResultPage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/userCenter',
          name: 'userCenter',
          component: UserCenterPage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/feedback',
          name: 'my-feedback',
          component: MyFeedback,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/redirect/wechat_callback',
          name: 'redirect-page',
          component: RedirectPage
        },
        {
          path: '/userCenter/redirect/wechat_callback',
          name: 'user-center-redirect-page',
          component: UserCenterRedirectPage
        }
      ]
    },
    {
      path: '/pdf-detail',
      name: 'PdfDetail',
      component: PdfDetailPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/error',
      name: 'error-page',
      component: ErrorPage
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // if (!authService.isLoggedIn()) {
    //   next({
    //     path: '/new-login',
    //     query: { redirect: to.fullPath }
    //   });
    // } else {
    //   NProgress.start();
    //   next();
    // }
  // } else {
    NProgress.start();
    next(); // 确保一定要调用 next()
  }
  if (to.path === '/error') {
    next();
  }
  localStorageHelper.setItem(FROM_ROUTER, from.path);
});
router.afterEach(() => {
  NProgress.done();
});

export default router;
